import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as navigator from '../../tools/Navigator'
import * as api from '../../tools/API'
import { SiteInfoWebDetails } from '../../tools/API'
import * as snacky from '../CustomSnackbarProvider'
import { useSnackbar } from 'notistack'
import { getErrorMessage } from '../../tools/Utils'
import { SiteDetailsLayout, SiteDetailsView } from './SiteDetailsView'
import { useSetTitle } from '../../tools/AppEvents'

interface SiteDetailsState {
  siteInfoWebDetails?: SiteInfoWebDetails
}

export function SiteDetailsInternalView({ siteId }: { siteId: number }) {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const [siteInfoWebDetails, setSiteInfoWebDetails] = useState(((navigator.getCurrentState() ?? {}) as SiteDetailsState).siteInfoWebDetails)
  const [loadingSite, setLoadingSite] = useState<boolean>(false)

  async function loadSite() {
    try {
      setLoadingSite(true)
      let siteInfoWebDetailsById = await api.getSiteInfoWebDetailsById(siteId)
      setSiteInfoWebDetails(siteInfoWebDetailsById)
    } catch (err) {
      console.log(`Error fetching: ${JSON.stringify(err)}`)
      enqueueSnackbar(t('errFetchSiteDetails', { message: getErrorMessage(err) }), snacky.errorOpts)
    } finally {
      setLoadingSite(false)
    }
  }

  useEffect(() => {
    // Site search results do not include 'files'.
    if (siteInfoWebDetails === undefined || siteInfoWebDetails.files === undefined) {
      loadSite()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useSetTitle(siteInfoWebDetails?.name ?? '')

  return (
    <SiteDetailsLayout loadingSite={loadingSite}>
      <SiteDetailsView
        siteInfoWebDetails={siteInfoWebDetails}
        loadSite={loadSite}
        siteId={siteId}
      />
    </SiteDetailsLayout>
  )
}
